exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navSideBar[data-v-ebdaa80c] {\n  flex: none;\n  width: 15rem;\n  margin-top: 10em;\n  margin-left: 0.5rem;\n}", ""]);

// exports
